<template>
  <div class="headDetails">
    <div class="abs cont">
      <img :src="imagePath" alt="">
      <img v-if="localData?.pid !== 7" src="@images/getProgressAward.png" alt="" class="getProgressAward" @click="pullEmail">
      <img v-else src="@images/getProgressAwardAll.png" alt="" class="getProgressAward" @click="pullEmail">
      <img src="@images/awardWaitTip.png" alt="">
    </div>
  </div>
</template>

<script>
import emitter from '@/utils/eventBus';
import { closePop, updateInitUser } from '@/utils/common.js';
import { getPrize } from '@/network/api'

export default {
  data(){
    return {
      localData: null
    }
  },
  mounted(){
    emitter.on('headDetails', data => {
      this.localData = data;
    })
  },
  computed: {
    imagePath(){
      let imgPath = '';
      switch (this.localData?.pid){
        case 4:
          imgPath = require('@images/progressAward1.png');
          break;
        case 5:
          imgPath = require('@images/progressAward2.png');
          break;
        case 6:
          imgPath = require('@images/progressAward3.png');
          break;
        case 7:
          imgPath = require('@images/progressAward4.png');
          break;
      }
      return imgPath;
    }
  },
  methods: {
    closePop,
    updateInitUser,
    pullEmail(){
      const pid = this.localData?.pid;
      getPrize({pid}).then(res => {
        if(res.status === 1){
          this.updateInitUser();
          this.closePop();
        }else{
          alert(res.message)
        }
      });
    }
  }
}
</script>

<style scoped>
.headDetails{ width: 649px; height: 617px; background: url(@images/HeadDetails.png) no-repeat 0 0;}
.cont{ top: 68px; left: 48px; width: 569px; height: 524px; display: flex; flex-wrap: wrap; justify-content: center; align-content: center;}
.getProgressAward{ margin: 30px 0 12px 0;}
</style>